import { ITripOutputDto } from './trip-output-dto.interface';

export interface IBulkCreateTripsOutputDto {
    data: ITripOutputDto[];
    errors: {
        message: string;
        tripCode?: string;
        index?: number;
    }[];
}
